export const ActionButton = {
	tag: 'Button',
	variant: 'solid',
	colorScheme: 'teal',
	size: 'sm',
	mr: 4,
};

export const CenterFlex = {
	tag: 'Flex',
	alignItems: 'center',
};

export const HorStack = {
	tag: 'HStack',
	spacing: 8,
	alignItems: 'center',
};

export const LinkStack = {
	tag: 'HStack',
	as: 'nav',
	spacing: 4,
	display: { base: 'none', md: 'flex' },
};

export const NarrowButton = {
	tag: 'IconButton',
	size: 'md',
	'aria-label': 'Open Menu',
	display: {
		md: 'none',
	},
};

export const NavLink = {
	tag: 'Link',
	px: 2,
	py: 1,
	rounded: 'md',
	_hover: {
		textDecoration: 'none',
		bg: ['gray.200', 'teal.300'],
	},
};

export const SmAvatar = {
	tag: 'Avatar',
	size: 'sm',
};

export const TopBox = {
	tag: 'Box',
	bg: ['gray.100', 'gray.700'],
	px: 4,
};

export const TopFlex = {
	tag: 'Flex',
	h: 16,
	alignItems: 'center',
	justifyContent: 'space-between',
};

export const UserButton = {
	tag: 'MenuButton',
	rounded: 'full',
	variant: 'link',
	cursor: 'pointer',
};
